export function abrirJanelaImpressao({
  html,
  title = "Impressao",
  printStyles = ""
}) {
  const janela = window.open("", "", "width=1100,height=900");

  if (!janela) return;

  const estilosAtuais = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style')
  )
    .map((node) => node.outerHTML)
    .join("\n");

  janela.document.write(`
    <html>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>${title}</title>
        ${estilosAtuais}
        ${printStyles ? `<style>${printStyles}</style>` : ""}
      </head>
      <body>
        ${html}
      </body>
    </html>
  `);

  janela.document.close();
  janela.onload = () => {
    janela.focus();

    setTimeout(() => {
      janela.print();
      janela.close();
    }, 300);
  };
}
